import { Flex, Typography } from "@papercup-ai/orizuru";
import { useEffect, useState } from "react";
import MaintenanceWorker from "../assets/svg/MaintenanceWorker";
import { formatMaintenanceEnd } from "../utils/systemMaintenance";

// The end phrase depends on the clock ("today", "tomorrow", past): refresh it
// so a tab left open stays truthful.
const CLOCK_TICK_MS = 60 * 1000;

/**
 * Full-viewport page shown instead of the app while the `system_maintenance`
 * flag is enabled (see MaintenanceGate). Generic copy; the only variable
 * part is the approximate end ops set in the flag value, shown in the
 * user's locale and time zone.
 */
export const SystemMaintenancePage = ({
  endDateTime
}: {
  endDateTime: Date | null;
}) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), CLOCK_TICK_MS);
    return () => clearInterval(timer);
  }, []);

  const endPhrase = endDateTime && formatMaintenanceEnd(endDateTime, now);
  const isOverdue = !!endDateTime && !endPhrase;

  return (
    <Flex
      as={"main"}
      role={"status"}
      aria-live={"polite"}
      position={"fixed"}
      inset={"0"}
      overflowY={"auto"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      gap={"12px"}
      padding={"32px"}
      backgroundColor={"background"}
      textAlign={"center"}
    >
      <MaintenanceWorker
        style={{ width: "min(360px, 80vw)", height: "auto" }}
      />
      <Typography variant={"heading2"}>
        We&apos;re down for maintenance
      </Typography>
      <Typography variant={"labelMedium"} maxWidth={"480px"}>
        The platform is temporarily unavailable while we carry out some
        maintenance. Please check back soon.
      </Typography>
      {endPhrase && (
        <Typography variant={"labelMedium"}>
          We expect to be back {endPhrase}.
        </Typography>
      )}
      {isOverdue && (
        <Typography variant={"labelMedium"}>
          This is taking a little longer than planned. Thanks for your patience.
        </Typography>
      )}
    </Flex>
  );
};
